module.exports = __webpack_public_path__ + "img/register-dark.4ec6b7de.svg";